var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// timeout with exponential backoff and jitter
const delay = (attempt, minTimeout, maxTimeout, jitter) => {
    const time = Math.min(maxTimeout, minTimeout * Math.pow(2, attempt));
    const timeout = jitter ? Math.floor(Math.random() * time) : time;
    return new Promise((resolve) => setTimeout(resolve, timeout));
};
const retry = (fn, { attempt = 0, retries = 3, minTimeout = 100, maxTimeout = Infinity, jitter = true, onRetry = undefined, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield fn();
    }
    catch (error) {
        if (attempt < retries) {
            onRetry === null || onRetry === void 0 ? void 0 : onRetry(attempt + 1, error, (value) => {
                throw value;
            });
            yield delay(attempt, minTimeout, maxTimeout, jitter);
            return retry(fn, {
                attempt: attempt + 1, retries, minTimeout, maxTimeout, jitter, onRetry,
            });
        }
        throw error;
    }
});
/**
 * @description
 * Retries the provided function with exponential backoff
 *
 * @param fn function to retry
 * @param options options to modify retry functionality
 * @param options.retries number of retry attempts (default: 3)
 * @param options.minTimeout minimum delay between retries in milliseconds (default: 100)
 * @param options.maxTimeout maximum delay between retries in milliseconds (default: Infinity)
 * @param options.jitter delay jitter enabled (default: true)
 * @param options.onRetry callback to run on retry with the following arguments
 * - attempt: attempt number
 * - error: Error or value thrown
 * - cancel: function to fail out and prevent further retries
 * @returns result of `fn`
 */
const retryWrapper = (fn, options) => __awaiter(void 0, void 0, void 0, function* () { return retry(fn, Object.assign(Object.assign({}, options), { attempt: 0 })); });
export { retryWrapper as retry };
//# sourceMappingURL=retry.js.map